import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Component that renders a tooltip.
 * Takes an Input of type ``{ text: string; link: string; title?: string; class?: string }``.
 *
 * @usageNotes
 * * ``link`` determines the hoverable text.
 * * ``title`` determines the title of the tooltip.
 * * ``text`` determines the tooltip content.
 * * ``class`` is applied to the tooltip link.
 *
 * All texts are translated.
 *
 */
@Component({
  selector: 'ish-field-tooltip',
  templateUrl: './field-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbPopover, NgClass, FaIconComponent, TranslateModule],
})
export class FieldTooltipComponent {
  readonly tooltipInfo = input.required<{
    text: string;
    link: string;
    title?: string;
    class?: string;
  }>();
}
